/**
 * @fileoverview Billing Admin Page (MOR-438)
 *
 * Purpose: Owner-only billing engine v1 — firm billing plans (Pilot /
 * Subscription / Per-Job), Stripe wiring, the charge ledger, and affiliate
 * agreements with per-period fee breakdowns.
 * URL: /admin/billing
 * Protection: owner-only (super_admin + owner allowlist). Never expose any
 * of this data to firm users.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@cvx/_generated/api";
import { BillingAdminView } from "@/components/admin/billing/BillingAdminView";
import { BillingStepUpGate } from "@/components/admin/billing/BillingStepUpGate";

export const Route = createFileRoute("/_app/_auth/admin/_layout/billing")({
  beforeLoad: async ({ context }) => {
    const user = await context.queryClient.ensureQueryData(
      convexQuery(api.users.queries.getCurrentUser, {}),
    );
    if (!user?.isOwner) {
      throw redirect({ to: "/admin/master-library" });
    }
  },
  component: BillingPage,
});

function BillingPage() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <div>
        <h1 className="text-2xl font-semibold">Billing</h1>
        <p className="text-sm text-muted-foreground">
          Firm billing plans, Stripe subscriptions, per-job fees and affiliate
          agreements. Internal billing view — never visible to firms.
        </p>
      </div>
      <BillingStepUpGate>
        <BillingAdminView />
      </BillingStepUpGate>
    </div>
  );
}
